import isEmpty from 'lodash/isEmpty';
import React, { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { AriaAttributes } from '../../../../../constants/AccessibilityConstants';
import { messages as m } from '../../../constants';
import * as D from '../../../deps';

import './EmptySearch.scss';

interface IEmptySearchProps {
  closeSearch: $TSFixMeFunction;
  ctaButton: ReactNode;
  filter: string;
  hasResults: boolean;
  isColdStartWelcome: boolean;
  isRightRailActive?: boolean;
  term: string;
}

class EmptySearch extends React.Component<IEmptySearchProps> {
  render(): $TSFixMe {
    const hasSearchTerm = !isEmpty(this.props.term);
    const classes = D.Utils.Css.createBEM('EmptySearch', {
      noResults: !this.props.hasResults && hasSearchTerm,
      coldStartWelcome: this.props.isColdStartWelcome,
    });

    const ariaAttributes = {};
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    ariaAttributes[AriaAttributes.LIVE] = 'polite';
    let title = (
      <h2 className='EmptySearch__content__title' {...ariaAttributes}>
        <FormattedMessage {...m.searchFor} />
      </h2>
    );

    if (!this.props.hasResults && hasSearchTerm) {
      let noResultsTitle;
      if (this.props.filter === D.FilterNavTypes.ALL) {
        noResultsTitle = <FormattedMessage {...m.noResults} />;
      } else {
        noResultsTitle = (
          <FormattedMessage {...m.noResultsFiltered} values={{ filter: this.props.filter }} />
        );
      }
      title = (
        <h2 className='EmptySearch__content__title' {...ariaAttributes}>
          {noResultsTitle}
          <br />
          &quot;
          <span className='EmptySearch__content__title__searchTerm'>{this.props.term}</span>
          &quot;
        </h2>
      );
    }

    return (
      <div className={classes}>
        {/*  eslint-disable  */}
        <div className='EmptySearch__wrapper' onClick={this.props.closeSearch}>
          {/*  eslint-enable  */}
          <p
            id='searchKeyboardControls'
            // @ts-expect-error TS(2322) FIXME: Type 'string' is not assignable to type 'number'.
            tabIndex='-1'
            aria-live='polite'
            className='visuallyHidden'
          >
            <FormattedMessage {...m.searchKeyboardControlsNoResults} />
          </p>
          <div className='EmptySearch__content'>
            {title}
            <h4 className='EmptySearch__content__subtitle'>
              <FormattedMessage {...m.wantHelp} />
            </h4>
            <div className='EmptySearch__buttonWrapper'>{this.props.ctaButton}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default EmptySearch;
